"use client";

import React, { useCallback, useState } from "react";
import Accordion from "@motorata/base-ui.components.molecules.accordion";
import { Label, P } from "@motorata/base-ui.components.atoms.typography";
import Link from "next/link";
import { addSpacesFromPhoneNumber } from "@motorata/base-ui.utils.string";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import Select from "@motorata/base-ui.components.atoms.select";
import { BRANDS_ARRAY, BRANDS_MOTO_ARRAY, MODELS_ARRAY } from "@motorata/base-ui.data";
import { ProfileType } from "@motorata/base-ui.types.api";
import { useRouter } from "next/navigation";
import MapBlock from "../../components/shared/MapBlock";

const ProfileContentSideBar = ({ profile, brand = null, model = null }: {
  profile: ProfileType
  brand?: string | null
  model?: string | null
}) => {
  const router = useRouter()

  const [state, setState] = useState({
    brand: brand,
    model: model
  })

  const onChange = useCallback(
    (obj: { name: string; value: any }) => {
      const { name, value } = obj
      const newState: any = {
        ...state,
        [name]: value,
      }
      if(name === "brand"){
        newState.model = null
      }

      setState(newState)

      let finalUrl = `/${profile.slug}`

      let params = ""
      if(newState.brand !== null && newState.brand !== ""){
        params = params.concat(`&brand=${newState.brand}`)
      }
      if(newState.model !== null && newState.model !== ""){
        params = params.concat(`&model=${newState.model}`)
      }

      router.push(`${finalUrl}${params !== "" ? `?${params}` : ""}`)
    },
    [state],
  )

  return (
    <Box>
      <Accordion padding="0px" wrapperProps={{ marginBottom: "S" }}>
        <Box>
          <Select
            name="brand"
            label="Marka"
            background="white"
            value={state.brand}
            onChange={(e) => onChange(e)}
            shrink={!!state.brand}
            options={BRANDS_ARRAY}
          />
        </Box>
          <Box>
            <Select
              name="model"
              label="Model"
              background="white"
              value={state.model}
              shrink={!!state.model}
              onChange={(e) => onChange(e)}
              options={MODELS_ARRAY[state.brand] ?? []}
            />
          </Box>
      </Accordion>
      <Accordion title="Dodatkowe informacje" paddingTop="0" wrapperProps={{
        marginBottom: "S"
      }}>
        {!!profile.description && (
          <Box marginTop="S">
            <Label type="secondary" icon="info-fill">
              Opis
            </Label>
            <P small margin="0 0 15px">
              {profile.description}
            </P>
          </Box>
        )}
        {profile.phone && (
          <Box marginTop="S">
            <Link href={`tel:${profile.phone}`}>
              <Label type="secondary" icon="phone-fill">
                {addSpacesFromPhoneNumber(profile.phone)}
              </Label>
            </Link>
          </Box>
        )}
        {profile.email && (
          <Box marginTop="S">
            <Link href={`mailto:${profile.email}`}>
              <Label type="secondary" icon="email-fill">
                {profile.email}
              </Label>
            </Link>
          </Box>
        )}
        {profile.website && (
          <Box marginTop="S">
            <Link href={`https://${profile.website}`}>
              <Label type="secondary" icon="earth-fill">
                {profile.website}
              </Label>
            </Link>
          </Box>
        )}
      </Accordion>
      <Accordion padding="0">
        <MapBlock height="300px" address={profile.address} type="company" />
      </Accordion>
    </Box>
  );
};

export default ProfileContentSideBar;
